export default __webpack_public_path__ + "static/media/document.bcaf6958.svg";